<ngx-loading-bar [color]="loadingBarColor"></ngx-loading-bar>
<nav class="tm-main-nav navbar navbar-expand-lg py-0 d-block d-md-flex justify-content-start w-100" [ngClass]="{devMode: devMode}">
  <div class="d-flex justify-content-between align-items-center">
    <a class="navbar-brand d-block px-2">TeamMood Admin</a>

    <span class="d-md-none px-2 fs-4" (click)="toggleNav = !toggleNav">
      <i class="far fa-bars"></i>
    </span>
  </div>

  @if(toggleNav){
    <ul class="navbar-nav d-md-flex flex-md-row-reverse flex-column-reverse justify-content-between" [ngClass]="{devMode: devMode}">
      <li class="nav-item mx-2">
        <a class="nav-link" href="/"><i class="far fa-home"></i> Front Office</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/email_templates">Email Templates</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/create_password">Create Password</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/email-provider-routing">Email Provider Routing</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/organizations">All Organisations</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/moderation">Moderation</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/app_errors">Errors @if (apperrorsNumber) {
          <span class="badge bg-danger">{{ apperrorsNumber }} </span>
        }</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/bounces">Bounces @if (bouncesNumber) {
          <span class="badge bg-danger">{{ bouncesNumber }} </span>
        }</a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-link" routerLink="/admin/search">Search</a>
      </li>
    </ul>
  }
</nav>

<div id="container" class="admin">
  <!-- Page Content -->
  <router-outlet></router-outlet>
</div>